<template>
  <multiselect 
    placeholder="Select Customer"
    :options="customers.data" 
    label="name" 
    track-by="id" 
    :value="selected" 
    @search-change="handleSearch"
    @input="handleInput" 
    @remove="handleRemove">
    <template slot="option" slot-scope="props">
      <div>{{ props.option.name }}</div>
      <div class="mt-1 text-sm text-gray-500 ">{{ props.option.email }}</div>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'CustomerSelect',

  components: {
    Multiselect
  },

  created () {
    this.getCustomers()
  },

  props: ['value'],

  computed: {
    selected () {
      return this.customers.data.find(customer => customer.id === this.value)
    }
  },

  data () {
    return {
      customers: {
        data: []
      }
    }
  },

  methods: {
    async getCustomers (query) {
      try {
        const { data } = await this.$api.get(`account/${this.$route.params.account}/customers`, {
          params: {
            filter: {
              search: query
            }
          }
        })
        this.customers = data.customers
        this.loading = false
      } catch (error) {
        console.error(error)
      }
    },

    handleSearch (query) {
      this.getCustomers(query)
    },

    handleInput (value) {
      this.$emit('input', value.id)
    },

    handleRemove () {
      this.$emit('input', null)
    }
  }
}
</script>